module.exports = __webpack_public_path__ + "img/default-toucan.82b66bd7.svg";